import { na1 } from 'hubspot-url-utils/hublets';
import { getFullUrlPure } from 'hubspot-url-utils/pure';
const DSN_KEY = 'eeb5bcc1447eba257645d7fee6f7a0b7';
const formatBaseUrl = ({
  hublet = na1,
  env
}) => {
  const base = getFullUrlPure('exceptions', hublet, env === 'qa' ? 'qa' : 'prod', {
    tldOverride: 'com'
  });
  return `${base}/v2/api/store?sentry_key=${DSN_KEY}`;
};
export default formatBaseUrl;